import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '@app/services/authentication.service';
import { AuthorizationService } from '@app/services/authorization.service';

@Injectable({ providedIn: 'root' })
export class HomeRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private authorizationService: AuthorizationService
  ) {}

  canActivate(): Observable<UrlTree> | UrlTree {
    if (this.authenticationService.isAuthenticated()) {
      return this.resolveDestination();
    }
    return this.authenticationService.ensureSession().pipe(
      map(isAuthenticated =>
        isAuthenticated ? this.resolveDestination() : this.router.parseUrl('/login')
      )
    );
  }

  private resolveDestination(): UrlTree {
    return this.authorizationService.isAdmin()
      ? this.router.parseUrl('/admin')
      : this.router.parseUrl('/user/customers');
  }
}